import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export const filterIframe = (
  iframe$: Observable<HTMLIFrameElement>,
): Observable<HTMLIFrameElement> =>
  iframe$.pipe(filter((iframe) => Boolean(iframe)));
